import styled from "styled-components";

export const RetryScreenTextDefaultBox = styled.div`
    margin-bottom: 1rem;
    font-size: 1.6rem;
    line-height: 1.5;
    color: ${({theme}) => theme.colors.bodyText.toString()};
`;
